/** Id of the page's `<main>`: the target of the skip link. */
export const MAIN_ID = "main-content";
